module.exports = __webpack_public_path__ + "img/check-icon.36f1615c.svg";